import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setAllProjects, setProjects } from "../../features/filter/filterSlice";
import { useGetProjectsQuery } from "../../features/project/projectsApi";

export default function ProjectItem({ project }) {
  // get all projects
  const { data: projects } = useGetProjectsQuery();
  const dispatch = useDispatch();
  const filterProjects = useSelector((state) => state.filter.projects);
  const { id, projectName, colorClass } = project;

  const handleCheck = (e) => {
    dispatch(setProjects(id));
  };

  useEffect(() => {
    // check all projects
    if (projects) {
      const allProjectsId = projects.map((project) => project.id);
      dispatch(setAllProjects(allProjectsId));
    }
  }, [dispatch, id, projects]);

  return (
    <div className="checkbox-container">
      <input
        id={`project-${id}`}
        type="checkbox"
        className={colorClass}
        onChange={handleCheck}
        checked={filterProjects.includes(id)}
      />
      <p className="label" htmlFor={`project-${id}`}>
        {projectName}
      </p>
    </div>
  );
}
